import React from 'react';
import {
  Container,
  styled,
  css,
  ProgressSteps,
  ProgressItem,
  ContainerProps,
} from '@erecruit/ui-kit';
import { useHistory, useLocation } from 'react-router';

import { PositionDetailsProps } from './PositionDetails';
import { MATCH_STATUSES_TRANSLATIONS, MATCH_STATUSES } from '../helpers';

const hoverableElement = (hover: boolean) => {
  return (
    hover &&
    css`
      &:hover {
        cursor: pointer;
      }
    `
  );
};

const ProgressContainer = styled(Container)<ContainerProps>(
  ({ theme: { newColors } }) => ({
    background: newColors.bgPagePrimary,
    height: 282,
    margin: '0px -16px!important',
  }),
);

type ProgressProps = Pick<PositionDetailsProps, 'counters'> & {
  numberOfPositions: number;
};

const Progress = ({ counters, numberOfPositions }: ProgressProps) => {
  const history = useHistory();
  const { pathname } = useLocation();

  if (!counters) return null;

  const percentage = numberOfPositions
    ? (counters.fullPlacement / numberOfPositions) * 100
    : 0;

  const pushRoute = (matchStatusParam: string) => {
    history.push(`${pathname}/${matchStatusParam}${history.location.search}`);
  };

  return (
    <ProgressContainer padding={7}>
      <ProgressSteps animated>
        <ProgressItem
          title={`${counters.submittals}`}
          subtitle={MATCH_STATUSES_TRANSLATIONS.submittals}
          onClick={
            counters.submittals
              ? () => {
                  pushRoute(MATCH_STATUSES.submittals);
                }
              : undefined
          }
          css={hoverableElement(!!counters.submittals)}
        />
        <ProgressItem
          title={`${counters.interview}`}
          subtitle={MATCH_STATUSES_TRANSLATIONS.interview}
          onClick={
            counters.interview
              ? () => {
                  pushRoute(MATCH_STATUSES.interview);
                }
              : undefined
          }
          css={hoverableElement(!!counters.interview)}
        />
        <ProgressItem
          title={`${counters.offers}`}
          subtitle={MATCH_STATUSES_TRANSLATIONS.offers}
          onClick={
            counters.offers
              ? () => {
                  pushRoute(MATCH_STATUSES.offers);
                }
              : undefined
          }
          css={hoverableElement(!!counters.offers)}
        />
        <ProgressItem
          title={`${counters.candidateAccepted}`}
          subtitle={MATCH_STATUSES_TRANSLATIONS.candidateAccepted}
          onClick={
            counters.candidateAccepted
              ? () => {
                  pushRoute(MATCH_STATUSES.candidateAccepted);
                }
              : undefined
          }
          css={hoverableElement(!!counters.candidateAccepted)}
        />
        <ProgressItem
          title={`${counters.fullPlacement}/${numberOfPositions}`}
          subtitle={MATCH_STATUSES_TRANSLATIONS.fullPlacement}
          percent={percentage}
          onClick={
            counters.fullPlacement
              ? () => {
                  pushRoute(MATCH_STATUSES.fullPlacement);
                }
              : undefined
          }
          css={hoverableElement(!!counters.fullPlacement)}
        />
      </ProgressSteps>
    </ProgressContainer>
  );
};

export default Progress;
